import React from "react";

import { useTranslation } from "utils";

import { Icon, Tooltip } from "components";

type ModuleIconProps = {
  module?: { module: string; icon: string };
  showTooltip?: boolean;
  background?: string;
  style?: React.CSSProperties;
};

export const ModuleIcon = ({ module, showTooltip = false, background = "white", style }: ModuleIconProps) => {
  const { t } = useTranslation("modules");

  if (!module) {
    return (
      <span className={`module-icon ${background}-background`} style={style}>
        <Icon className="icon inline" iconName="tabler/lock" />
      </span>
    );
  }

  return (
    <span className={`module-icon ${background}-background`} style={style}>
      {showTooltip ? (
        <Tooltip placement="top" title={t(`modules.${module.module}.name`)}>
          <Icon iconName={module.icon} />
        </Tooltip>
      ) : (
        <Icon iconName={module.icon} />
      )}
    </span>
  );
};

export default Icon;
